<template>
  <tbody class="merchant-contact table center">
    <tr>
      <th colspan="10">历史记录</th>
    </tr>
    <template v-for="(item, index) of details">
      <tr :key="index + '-3'">
        <th
          colspan="10"
          style="text-align:left; padding-left:20px;"
          v-html="index + 1"
        ></th>
      </tr>
      <tr :key="index + '-4'">
        <!-- <td style="position: reactive">
          <span style="position: absolute; bottom: 0; height: 25px">1</span>
        </td> -->
        <td>进件时间</td>
        <td>
          <date-picker v-model="item.createTime" time :readonly="readonly" />
          <!-- <el-input :value="item.createTime" :readonly="readonly" /> -->
        </td>
        <td>拓展人员</td>
        <td>
          <el-input :value="expandUserName" :readonly="readonly" />
        </td>
        <td>重要提示</td>
        <td>
          <el-input :value="item.opinion" :readonly="readonly" />
          <!-- <common-select
            v-model="item.start"
            :list="selects.elementfailList"
            :readonly="readonly"
          /> -->
        </td>
        <td>受理复核</td>
        <td>
          <common-select
            v-model="item.acceptanceReview"
            :list="selects.artificialAuditList"
            :readonly="readonly"
          />
        </td>
        <td>复核人员</td>
        <td>
          <el-input :value="item.checkName" :readonly="readonly" />
        </td>
      </tr>
      <tr :key="index + '-5'">
        <td>驳回理由</td>
        <td colspan="3">
          <el-input v-model="item.reason" :readonly="readonly" />
        </td>
        <td>信息修改项</td>
        <td colspan="5">
          <el-input v-model="item.updateInfo" :readonly="readonly" />
        </td>
      </tr>
    </template>

    <slot></slot>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    details: {
      type: Array,
      default() {
        return []
      },
      comment: '历史系统审核信息'
    },
    expandUserName: {
      type: String,
      default() {
        return ''
      },
      comment: '拓展人员'
    },
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否不能编辑内容'
    }
  },

  data() {
    return {}
  },
  computed: {
    ...mapGetters(['selects'])
  },
  created() {
    // this.details = [
    //   {
    //     id: '1',
    //     supId: '1',
    //     createTime: '1',
    //     opinion: '1',
    //     acceptanceReview: '1',
    //     checkName: '1',
    //     reason: '1',
    //     updateInfo: '1',
    //     checkTime: '1'
    //   }
    // ]
    // console.log(this.details, 123)
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/detailsTable.scss';
</style>
